import { Tooltip } from 'antd'
import { get, cloneDeep } from 'lodash-es'

export default {
  rowSelection: false,
  autoRequest: false,
  columns: [
    { title: '职位编码', dataIndex: 'code', width: 160, ellipsis: true },
    { title: '职位名称', dataIndex: 'name', width: 130, ellipsis: true },
    { title: '岗位编码', dataIndex: 'positionCode', width: 100, ellipsis: true },
    { title: '岗位名称', dataIndex: 'positionName', width: 150, ellipsis: true },
    {
      title: '所属组织',
      dataIndex: 'departPosition',
      width: 300,
      render: (text: any, record: any) => {
        if (!text) return record.departPosition
        const _text = text.deptParentName + '/' + text.deptName
        return (
          <Tooltip overlay={_text}>
            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {text.deptParentName + '/' + text.deptName}
            </div>
          </Tooltip>
        )
      },
    },
    {
      title: '组织负责人',
      key: 'personInChargeWorkNumber',
      dataIndex: 'departPosition',
      width: 200,
      render: (text: any) => {
        return text?.personInChargeName
      },
    },
    {
      title: '主职位',
      key: 'mainPosition',
      width: 80,
      align: 'center',
      render: 'mainPositionRender',
    },
    {
      title: '直接上级',
      key: 'superiorName',
      dataIndex: 'superiorName',
      width: 200,
      render: 'superiorNameRender',
    },

    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 100,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
}
